import { IErrMsg } from '../../../components/inputs/types'
import { INT_REGEX } from '../../../components/models/Integer/consts'
import { validateIntegerConstraints } from './helpers'

export function integerInputErrors(
    state: any,
    schema: any
): IErrMsg | undefined {
    if (schema.is_required && !state) {
        return { message: 'errors.validation.fieldRequired' }
    }

    if (String(state).includes('e')) {
        return { message: 'errors.validation.numbersOnly' }
    }

    const parsed = parseIntToBigInt(state)

    if (parsed.error) {
        return parsed.error
    }

    if (parsed.value === null) {
        if (schema.is_required) {
            return { message: 'errors.validation.fieldRequired' }
        }
        return undefined
    }

    return validateIntegerConstraints(parsed.value, schema)
}

function parseIntToBigInt(state: any): {
    value: bigint | null
    error?: IErrMsg
} {
    if (state == null) {
        return { value: null }
    }

    const stateStr = String(state).trim()

    if (stateStr === '') {
        return { value: null }
    }

    if (stateStr.includes('.')) {
        return {
            value: null,
            error: { message: 'errors.validation.mustBeAnInteger' },
        }
    }

    if (!INT_REGEX.test(stateStr)) {
        return {
            value: null,
            error: { message: 'errors.validation.invalidValue' },
        }
    }

    try {
        return { value: BigInt(stateStr) }
    } catch {
        return {
            value: null,
            error: { message: 'errors.validation.invalidValue' },
        }
    }
}
